import { CoreButton, CoreInput } from '@components'
import { useEditExternalWalletQry } from 'mmfintech-backend-api'

import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useEffect } from 'react'

const CreateKingdomRecipient = ({ currencyCode, onClose, onSuccess }) => {
  const { formValues, handleSubmit, error, fetching, resetMutations } = useEditExternalWalletQry({
    type: 'KINGDOM_WALLET',
    // recipientId,
    currencyCode,
    onSuccess: (response: any) => onSuccess(response?.paymentInstrumentId),
    onClose
  })

  // const { countryOptions } = useCountries('WITHDRAWAL')

  useEffect(() => {
    return () => {
      resetMutations()
    }
  }, [])

  return (
    <>
      <CoreInput
        type='text'
        data-test='account-name'
        label={tr('FRONTEND.RECIPIENTS.JETON.NAME', 'Name')}
        {...formValues.registerInput('name')}
        autoComplete='off'
      />

      {/*<CoreSelect
        type='country'
        data-test='address'
        options={countryOptions}
        label={tr('FRONTEND.RECIPIENTS.JETON.COUNTRY', 'Country')}
        {...formValues.registerInput('countryCode')}
      />*/}

      {/*<CoreInput
        type='text'
        data-test='identifier'
        label={tr('FRONTEND.RECIPIENTS.JETON.IDENTIFIER', 'Identifier')}
        {...formValues.registerInput('identifier')}
        autoComplete='off'
      />*/}

      <CoreInput
        type='email'
        data-test='email'
        label={tr('FRONTEND.RECIPIENTS.JETON.EMAIL', 'Email')}
        {...formValues.registerInput('email', (email: string) => {
          formValues.setValue('identifier', email)
        })}
        autoComplete='off'
      />

      {/*<CoreInput
        type='text'
        data-test='firstName'
        label={tr('FRONTEND.RECIPIENTS.JETON.FIRST_NAME', 'First name')}
        {...formValues.registerInput('firstName')}
        autoComplete='off'
      />
      <CoreInput
        type='text'
        data-test='lastName'
        label={tr('FRONTEND.RECIPIENTS.JETON.LAST_NAME', 'Last name')}
        {...formValues.registerInput('lastName')}
        autoComplete='off'
      />*/}

      <CoreInput
        type='text'
        data-test='description'
        label={tr('FRONTEND.RECIPIENTS.JETON.DESCRIPTION', 'Description')}
        {...formValues.registerInput('description')}
        autoComplete='off'
      />

      <ErrorDisplay error={error} />

      <CoreButton
        type='button'
        data-test='save-button'
        variation='elevated'
        size='large'
        text={tr('FRONTEND.RECIPIENTS.EDIT.BUTTON_SAVE_RECIPIENT', 'Save recipient')}
        className='save-button'
        onClick={handleSubmit}
        isLoading={fetching}
        disabled={fetching}
        fullWidth
      />
    </>
  )
}

export default CreateKingdomRecipient
